<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.class}`"
    :data-type="context.type"
  >
    <p
      v-if="!companyId"
      class="text-muted mb-0"
    >{{ $t('formulateCompanySitesManager.noCompany') }}</p>
    <template v-else>
      <!-- what is still missing -- the form stays invalid (the task cannot be submitted) until this is empty -->
      <b-alert
        :show="!localDisabled && problems.length > 0"
        variant="warning"
        class="mt-3 mb-0"
      >
        <div class="font-weight-bold mb-1 text-center">{{ $t('formulateCompanySitesManager.stillNeeded') }}</div>
        <!-- <ul class="mb-0 pl-4">
          <li
            v-for="(problem, idx) in problems"
            :key="idx"
          >{{ problem }}</li>
        </ul> -->
      </b-alert>
      <shared-company-sites-manager
        :company-id="companyId"
        :read-only="localDisabled"
        :no-shadow="noShadow"
        @sites-loaded="onSitesLoaded"
      ></shared-company-sites-manager>
    </template>
  </div>
</template>

<script>
// a company's sites, managed right in a flow form (SharedCompanySitesManager) -- for the backend CompanySitesInput (renderer key
// 'company_sites_manager') -- Oct 2026
// the sites are saved through the CompanySite workflow as the user works -- this input only CHECKS them:
// its value is the list of what is still missing (the backend sends the starting list; it is rebuilt here every time the sites
// reload), and the 'companySitesComplete' rule keeps the form invalid until it is empty. The backend checks again when the form saves.
// KEEP IN SYNC with vendors.services.sites.get_company_site_problems: at least one site, and every new / active site complete
// (each site's 'problems' from the site API)
import isEqual from 'lodash/isEqual';
import SharedCompanySitesManager from '@/components/vendors/components/SharedCompanySitesManager.vue';

const CHECKED_STATES = ['new', 'active']; // inactive / removed sites are not checked

export default {
  name: 'FormulateCompanySitesManager',
  components: {
    SharedCompanySitesManager,
  },
  i18n: {
    // English only for now -- other languages fall back to English
    messages: {
      en: {
        formulateCompanySitesManager: {
          noCompany: 'There is no company to add sites for.',
          stillNeeded: 'Some site information is incomplete or invalid.  Please complete it before continuing.',
          addOneSite: 'Add at least one site for your company.',
        },
      },
    },
  },
  props: {
    context: {
      // standard Formulate input context
      type: Object,
      required: true,
    },
    companyId: {
      type: String,
      default: '',
    },
    noShadow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localDisabled() {
      return this.context.attributes?.disabled ?? this.context.disabled ?? false;
    },
    problems() {
      return Array.isArray(this.context.model) ? this.context.model : [];
    },
  },
  methods: {
    onSitesLoaded(sites) {
      if (this.localDisabled) return; // read-only (like a completed task) -- nothing to check
      const checkedSites = (sites || []).filter((site) => CHECKED_STATES.includes(site.sm_state));
      const problems = checkedSites.length
        ? checkedSites.flatMap((site) => site.problems || [])
        : [this.$t('formulateCompanySitesManager.addOneSite')];
      if (!isEqual(problems, this.context.model)) {
        this.context.model = problems;
      }
    },
  },
};
</script>
